import orderApi from './orderApi';
import channelApi from './channelApi';

export default {
  ...orderApi,
  ...channelApi,
};
